import { CoreRuDict, DictTranslationService } from '@prodcard/core'

export const translationService = new DictTranslationService({
  dicts: { ru: CoreRuDict },
  fallbackLangCode: 'ru',
})
